import React from 'react';
import PropTypes from 'prop-types';
import Field from "./field";
import ActionButton from "./action_button";

const AmplifyConfiguration = props => {
  const hc = props.handleChange;
  return (
    <form className="form">
      <Field id="region" value={props.region} handleChange={hc} label="Region"/>
      <Field id="userPoolId" label="User Pool ID" value={props.poolId} handleChange={hc}/>
      <Field id="userPoolWebClientId" value={props.clientSecret} handleChange={hc}
             label="User Pool WebClient ID"/>

      <div id="actions">
        <ActionButton onClick={props.onConfigure} text="Configure"/>
        <ActionButton onClick={props.onSignOut} text="Sign Out"/>
        <ActionButton onClick={props.onGetJwt} text="Get JWT"/>
      </div>
    </form>);
};

AmplifyConfiguration.propTypes = {
  region: PropTypes.string.isRequired,
  poolId: PropTypes.string.isRequired,
  clientSecret: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  onConfigure: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  onGetJwt: PropTypes.func.isRequired,
};

export default AmplifyConfiguration;